import { render, staticRenderFns, recyclableRender, components } from "./resetpwd.vue?vue&type=template&id=0846830b&"
var renderjs
import script from "./resetpwd.vue?vue&type=script&lang=js&"
export * from "./resetpwd.vue?vue&type=script&lang=js&"
import style0 from "./resetpwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/public/resetpwd.vue"
export default component.exports